export default "__VITE_ASSET__l00rgXWu__"